<template>
  <div class="gm-page-content energy-storage-centralized d-flex ga-4">
    <DeviceTree :loading="loading" :items="items" v-model:selectedId="selectedId" :onlineStatus="onlineStatus" @select="onSelect" @search="onSearch">
    </DeviceTree>


    <Galaxy v-if="deviceId && deviceType" :galaxy="getGalaxyById(deviceId)" :eLink="getELinkByGalaxyId(deviceId)"
      :stationId="stationId" />

    <div class="device-cards-container" v-else>
      <div class="device-cards">
        <DeviceCard v-for="item in items?.[0]?.children" :key="item.id" :item="item"
          :real-data="getRealDataById(item.uuid)" showUuid />
      </div>
    </div>


  </div>
</template>
<script setup>
import DeviceTree from './components/DeviceTree/index.vue'
import DeviceCard from './components/DeviceCard/index.vue'
import Galaxy from './DeviceDetail/Galaxy.vue'
import { onMounted, onUnmounted, ref, computed, watch } from 'vue'
import { ws_req } from '@/ws/wss-request'
import { useRoute, useRouter } from 'vue-router'
import { useRealData } from '@/hooks/useRealData'
import { useDeviceList } from '@/hooks/useDeviceList'

const router = useRouter()
const route = useRoute()


const props = defineProps({
  stationId: {
    type: [String, Number],
    required: true
  }
})

const selectedId = ref([route.query.deviceId || ''])
const deviceId = computed(() => route.query.deviceId)
const deviceType = computed(() => route.query.deviceType)

const onlineStatus = computed(() => {
  return realData.value.reduce((acc, item) => {
    acc[item.uuid] = item.is_online !== void 0
    return acc
  }, {})
})

async function onSelect(params) {
  console.log('params', params)
  highlightDeviceElement(document.getElementById(`device-${params.id}`))

  // // 有设备ID，是详情页点击
  if (deviceId.value) {
    // const type = getDeviceType(params.id)
    router.replace({
      path: '/station-monitor/detail',
      query: { ...route.query, deviceId: params.id }
    })
    return
  }

  const deviceElement = document.getElementById(`device-${params.id}`)
  if (deviceElement) {
    deviceElement.scrollIntoView({ behavior: 'smooth' })
    highlightDeviceElement(deviceElement)
  }
}

// 使用JS调用实现高亮动画
function highlightDeviceElement(element) {
  if (!element) return;
  // 闪烁3次
  element.animate([
    { boxShadow: 'none', borderColor: 'rgba(244, 247, 252, 1)' },
    { boxShadow: '0 0 12px rgba(58, 104, 255, 0.5)', borderColor: 'rgba(58, 104, 255, 1)' },
  ], { duration: 500, easing: 'ease-in-out', iterations: 4, direction: 'alternate-reverse' })
}

function onSearch(v) {
  console.log('search', v)
}

const { items, loading, getGalaxyById, getELinkByGalaxyId } = useDeviceList(props.stationId)
const { realData, updateOnce } = useRealData({
  interval: 2000,
  immediate: true,
  initData: [],
  updateFunction: () => {
    return ws_req.request('galaxy_overview', {
      stationId: props.stationId
    })
  }
})

watch(() => props.stationId, (newVal) => {
  if (newVal) {
    updateOnce()
  }
})

/**
 * 根据uuid获取实时数据
 * @param uuid  
 */
function getRealDataById(uuid) {
  for (const item of realData.value) {
    if (item.uuid === uuid) {
      return item
    }
  }
  return {}
}



</script>

<style scoped lang="scss">
.energy-storage-centralized {
  min-width: 0;
  max-width: 100%;
  overflow-x: hidden;
}

.device-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 12px;
  align-content: start;
  min-width: 0;
}

.device-cards-container {
  flex: 1 1 0;
  min-width: 0;
  padding-right: 16px;
  padding-bottom: 16px;
  overflow-y: auto;
}

@media (max-width: 1024px) {
  .energy-storage-centralized {
    flex-direction: column;
  }
}

@media (max-width: 768px) {
  .device-cards {
    grid-template-columns: minmax(0, 1fr);
  }

  .device-cards-container {
    padding-right: 8px;
  }
}
</style>
